import React, { useEffect, useRef, useState } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import './Otp.css';
import Topbar from "../../Topbar";
import Footer from "../../Footer";
import { useNavigate } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import {validateforotp} from '../../../Utils/validate';
import loader from '../../../assests/loader.gif';
import API from '../../../Utils/Api';
import { gettoastwarning } from '../../../Utils/Common';


const Otp = () => {
	const [loading,setLoading] = useState(false);
	const navigate = useNavigate();

	const [errors,setErrors] = useState({});
	const [email,setEmail] = useState();

	useEffect(() => {
		document.title = `OTP | Local Bells`;
		document.getElementById('bodywrap').className = 'neotp';

		if (localStorage.getItem('email') !== null) {
			setEmail(localStorage.getItem('email'));
		}else
		{		
			window.location.href = "/neighbour/forgot-password";
		}
		localStorage.removeItem("otp");

	}, []);

	

	const [otp, setOtp] = useState(new Array(6).fill(''));
	const inputRefs = useRef([]);

	const handleChange = (element, index) => {
		const value = element.value.replace(/[^0-9]/g, ''); // Only digits
		if (value) {
			const newOtp = [...otp];
			newOtp[index] = value;
			setOtp(newOtp);

			// Move to next input
			if (index < 5) {
				inputRefs.current[index + 1].focus();
			}
		}
	};

	const handleKeyDown = (e, index) => {
		if (e.key === 'Backspace') {
			if (otp[index] === '') {
				if (index > 0) {
					inputRefs.current[index - 1].focus();
				}
			} else {
				const newOtp = [...otp];
				newOtp[index] = '';
				setOtp(newOtp);
			}
		}
	};

	const handlePaste = (e) => {
		e.preventDefault();
		const pasteData = e.clipboardData.getData('text').slice(0, 6);
		if (/^\d+$/.test(pasteData)) {
			const newOtp = pasteData.split('').slice(0, 6);
			setOtp(newOtp);
			newOtp.forEach((digit, i) => {
				if (inputRefs.current[i]) {
					inputRefs.current[i].value = digit;
				}
			});
			if (inputRefs.current[5]) {
				inputRefs.current[5].focus();
			}
		}
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		const validationErrors = validateforotp(otp);
		  const noErrors = Object.keys(validationErrors).length === 0;
		  setErrors(validationErrors);
		  if(noErrors){
		  	setLoading(true);

		  	var ot='';
		    otp.forEach((item, index) => {
		      ot+=item;
		    })

		    let formData = new FormData(); 
		    formData.append('email', email);
		    formData.append('type', 1);
		    formData.append('code', ot);
		    API.post('code_check', formData)
		      .then(response => {
		      if(response.data.status === false){
		        //setError(response.data.message);
		        setLoading(false); 
		        gettoastwarning(response.data.message,'');
		      }else{
		         setLoading(false);
		         localStorage.setItem("otp", otp);
				navigate('/neighbour/new-password');
		      }                  
		    }).catch(error => {
		       setLoading(false);
		       gettoastwarning("Something went wrong. Please try again later.",'');
		        //setError("Something went wrong. Please try again later.");
		    });	
		}
	};

	return (
		<>
			<Topbar />
			<Container>
				<section className='signup-main'>
						<Row className='justify-content-center'>
							<Col md={8} lg={5} xs={12}>
								<div className="signup-form-box otp-form-box">
									<div className='sfb-title mb-5'>
										<h2><span>OTP</span></h2>
										<h5>otp verification</h5>
									</div>
									<Form onSubmit={handleSubmit}>
										<div onPaste={handlePaste} style={{ display: 'flex', gap: '10px', marginBottom:15, }}>
											{otp.map((digit, index) => (
												<input
													key={index}
													type="text"
													inputMode="numeric"
													maxLength="1"
													value={digit}
													onChange={(e) => handleChange(e.target, index)}
													onKeyDown={(e) => handleKeyDown(e, index)}
													ref={(el) => (inputRefs.current[index] = el)}
													style={{
														width: '40px',
														height: '40px',
														textAlign: 'center',

													}}
												/>
											))}
										</div>
										{errors.otp && (<p className="text-danger text-start mb-1">{errors.otp}</p>)}
										<Button variant="primary" type="submit" className='blue-btn'>
											<h6>Submit</h6>
										</Button>
									</Form>
								</div>
							</Col>
						</Row>
				</section>
			</Container>
			<Footer />
			{loading && (
		       <div className="loadingClass">
		        <img src={loader} alt="loader"/>
		      </div>
		       )}  
		</>
	)
}

export default Otp;


